<template>
    <div class="activity">
        <router-view class="router" :keyword="searchKeyword"></router-view>
        <div class="btn-menu" @click="showBackButton = !showBackButton">
            <a-icon type="menu-unfold" v-if="showBackButton"/>
            <a-icon type="menu-fold" v-if="!showBackButton"/>
        </div>
        <div :class="{'menus': true, 'show': !showBackButton}">
            <div class="search-box">
                <input type="text" v-model="keyword" class="keyword" placeholder="請輸入搜索關鍵字" @keyup="onKeyUp">
                <button @click="doSearch"><a-icon type="search" class="icon"/>搜索</button>
            </div>
            <div class="list">
                <div class="head"><a-icon type="bars" class="icon"/>最近活動</div>
                <ul class="datas">
                    <li class="item" v-for="(data, index) in dataList" :key="index" @click="showBackButton=true">
                        <router-link :to="`/ActivityDetail/${data.activityid}`" v-text="data.title"></router-link>
                    </li>
                    <loading v-if="loading"/>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from '../../components/Loading'
export default {
    components: {
        Loading,
    },
    data(){
        return {
            mode: 'top',
            title: '',
            keyword: '',
            searchKeyword: '',
            detail: null,
            loading: false,
            dataList: [],
            showBackButton: true,
        }
    },
    mounted: function(){
        this.keyword = this.$route.query.keyword || ''
        this.onRefresh()
    },
    methods: {
        onKeyUp: function(e) {
            if(e.key === 'Enter') {
                this.doSearch()
            }
        },
        doSearch: function(){
            var keyword = this.keyword.trim()
            var params = keyword ? `?keyword=${keyword}` : ''
            var path = `/ActivityList${params}`
            if(location.href.endsWith(path)) {
                this.searchKeyword = null
                setTimeout(() => {
                    this.searchKeyword = keyword
                }, 10)
            } else {
                this.$router.push(`/ActivityList${params}`)
            }
        },
        onRefresh: function(){
            this.loading = true
            this.$store.dispatch('getNewActivityList', {'associationid': 4})
            .then((rs)=>{
                this.loading = false
                this.dataList = rs.list || []
            })
            .catch((error)=>{
                this.loading = false
                this.$message.warning(error || '操作失敗，請稍後重試')
            })
        }
    },
    watch: {
        '$route.query.keyword': function(keyword) {
            this.keyword = keyword || ''
        },
    }
}
</script>

<style scoped>
    .activity {
        width: 1000px;
        margin: 0px auto;
        display: flex;
        position: relative;
    }

    .activity > .router {
        flex: 1;
        margin-right: 20px;
    }

    .activity > .menus {
        width: 260px;
        display: flex;
        flex-direction: column;
    }

    .activity> .menus > .search-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
    }

    .activity> .menus > .search-box > input {
        flex: 1;
        height: 40px;
        line-height: 40px;
        padding-left: 12px;
        border: 1px solid #e8e8e8;
        color: #232323;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 14px;
        border-right: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .activity> .menus > .search-box > button {
        height: 40px;
        width: 80px;
        border: 1px solid #e8e8e8;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        color: #232323;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 400;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .activity> .menus > .search-box > button:active {
        opacity: 0.7;
    }

    .activity> .menus > .search-box > button > .icon {
        margin-right: 8px;
    }

    .activity > .menus > .list {
        display: flex;
        flex-direction: column;
        background-color: #fff;
        box-shadow: 2px 2px 3px #e8e8e8;
        border: 1px solid #e8e8e8;
    }

    .activity > .menus > .list > .head {
        height: 33px;
        line-height: 33px;
        padding-left: 12px;
        font-size: 16px;
        font-weight: bold;
        color: #31708f;
        background-image: linear-gradient(to bottom,#d9edf7 0,#c4e3f3 100%);
    }

    .activity > .menus > .list > .head > .icon {
        margin-right: 8px;
    }

    .activity > .menus > .list > .datas {
        padding: 0 12px;
        position: relative;
    }

    .activity > .menus > .list > .datas > .item {
        line-height: 30px;
        position: relative;
        box-sizing: border-box;
        font-size: 15px;
        font-weight: 400;
        color: #333;
        border-bottom: 1px dashed #e8e8e8;
        padding-left: 33px;
        overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
    }

    .activity > .menus > .list > .datas > .item::after {
        content: '1';
        background-color: #d9534f;
        position: absolute;
        left: 7px;
        top: 7px;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        border-radius: 2px;
        font-weight: 400;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(2)::after {
        content: '2';
        background-color: #d9534f;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(2)::after {
        content: '2';
        background-color: #d9534f;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(2)::after {
        content: '2';
        background-color: #d9af4f;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(3)::after {
        content: '3';
        background-color:#0365f9;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(4)::after {
        content: '4';
        background-color: #1890ff;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(5)::after {
        content: '5';
        background-color: #4b93ec;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(6)::after {
        content: '6';
        background-color: #6203f9;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(7)::after {
        content: '7';
        background-color: #8217e4;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(8)::after {
        content: '8';
        background-color: #a02bb5;
    }
    
    .activity > .menus > .list > .datas > .item:nth-child(9)::after {
        content: '9';
        background-color:#9174d6;
    }

    .activity > .menus > .list > .datas > .item:last-child {
        border-bottom: 0;
    }

    .activity > .btn-menu {
        position: fixed;
        left: 11px;
        top: 89px;
        width: 40px;
        height: 40px;
        border: 1px solid #e8e8e8;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 2px 2px 5px #eee, -2px -2px 5px #eee;
        display: none;
        align-items: center;
        justify-content: center;

    }

    .activity > .btn-menu:active {
        opacity: 0.7;
    }

    @media only screen and (max-width: 1050px) {
        .activity {
            width: 100%;
            margin-top: 42px;
        }

        .activity > .menus {
            position: absolute;
            width: 80%;
            background-color: #fff;
            box-shadow: 2px 2px 5px #ccc;
            border-radius: 8px;
            padding: 8px;
            display: none;
        }

        .activity > .menus.show {
            display: flex;
        }

        .activity > .btn-menu {
            display: flex;
        }

        .activity > .menus {
            position: absolute;
            width: 80%;
            background-color: #fff;
            box-shadow: 2px 2px 5px #ccc;
            border-radius: 8px;
            padding: 8px;
            display: none;
        }

        .activity > .menus.show {
            display: flex;
        }

        .activity > .router {
            /* margin: 0 12px; */
        }

        .activity > .btn-menu {
            display: flex;
        }
    }
</style>
